<template>
  <el-dialog
      :visible.sync="visible"
      title="物料工艺设置"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="80%"
  >
    <div class="table-bar" v-if="parentProductList.length>0" style="flex-wrap: wrap;justify-content: flex-start;margin-bottom: 10px;">
      <el-tag v-for="item in parentProductList" :key="item.id" type="primary" closable @close="removeBind(item)"
              style="margin-right: 10px;">
        {{ $productName(item) }}
      </el-tag>
    </div>
    <SweetTable url="/trade/bom/list/upflow" ref="table" :selection="true" :is-page="false" :query-form="queryForm"
                :height="400">
      <el-table-column
          prop="materialInfo.name"
          label="品名"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          prop="materialInfo.color"
          label="颜色"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          prop="materialInfo.size"
          label="规格"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          prop="materialInfo.attr1"
          label="幅宽"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          prop="materialInfo.attr2"
          label="克重"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      ></el-table-column>
    </SweetTable>
    <template slot="footer">
      <el-button @click="visible=false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{
          $t('confirm')
        }}
      </el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'

export default {
  name: 'up-flow-dialog',
  data () {
    return {
      visible: false,
      parentProductList: [],
      queryForm: {
        orderId: '',
        materialId: ''
      }
    }
  },
  methods: {
    //
    init (orderId, materialId) {
      this.queryForm.orderId = orderId
      this.queryForm.materialId = materialId

      this.visible = true
      this.$nextTick(() => {
        this.$refs.table.reload()
        this.queryParentProductList()
      })
    },
    //删除已绑定的上游物料关联关系
    removeBind (item) {
      this.$confirm('是否移除关联?', '操作提示').then(() => {
        this.$api2.post(`/trade/product/parent/remove`, {
          id:item.refId
        }).then(res => {
          this.queryParentProductList()
        })
      })
    },
    //读取已绑定的上游物料
    async queryParentProductList () {
      const data = await this.$api2.get(`/trade/product/parent/list/${this.queryForm.orderId}/${this.queryForm.materialId}`)
      console.log('queryParentProductList',data)
      this.parentProductList = data
    },

    //保存提交
    dataFormSubmitHandle: debounce(function () {
          let selData = this.$refs.table.dataListSelections
          if (selData.length === 0) {
            return this.$message.error('请选择要绑定的上游物料')
          }
          let postData = {
            productId: this.queryForm.materialId,
            parentIds: selData.map(item => item.materialInfo.id),
            orderId:this.queryForm.orderId
          }
          console.log(this.dataListSelections)
          this.$api2.post(`/trade/product/bind`, postData).then(res => {
            this.$message.success('操作成功')
            this.$emit('refreshDataList')
            this.visible = false
          })
        },
        1000,
        { leading: true, trailing: false }
    )
  }
}
</script>

<style scoped>

</style>
